import React from 'react'
import {sortBy} from 'lodash'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'

import CollaboratorModal from './modals/CollaboratorModal'
import DeleteModal from '../../components/DeleteModal'

import * as collaboratorService from '../../services/collaborator-service'

export default class Collaborators extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.buttonFormatter = this.buttonFormatter.bind(this)
    this.deleteId = this.deleteId.bind(this)

    this.state = {
      collaborator: undefined
    }
  }

  deleteId(id) {
    collaboratorService.deleteCollaborator(id).then(() => this.props.refresh())
  }
  
  buttonFormatter(cell, row, id) {
    return (
      <div className='row-actions'>
        <CollaboratorModal
          title="Wijzigen medewerker"
          modalbttext="Wijzigen"
          id={row.id}
          text="Wilt u de gegevens van deze medewerker wijzigen?"
          reload={() => this.props.refresh()} />

        <DeleteModal
          title="Verwijderen medewerker"
          text="Wilt u de gegevens van deze medewerker verwijderen?"
          className='delete-entry action-btn'
          delete={() => this.deleteId(row.id)}>
        </DeleteModal>
      </div>
    )
  }

  render() {
    function headerFormatter(column, colIndex, { sortElement }) {
      return (
        <span className="sortable-inner">
          <span className="text">{column.text}</span>
          {sortElement}
        </span>
      )
    }

    function contentFormatter(cell, row) {
      return (
        <span className="text">{cell}</span>
      )
    }

    const { collaborators } = this.props

    const columns = [{
      dataField: 'fullName',
      text: 'Naam',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'locationName',
      text: 'Locatie',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'organizationalUnitName',
      text: 'Organisatorische eenheid',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: contentFormatter
    }, {
      dataField: 'button',
      text: ' ',
      formatter: this.buttonFormatter
    }]

    const paginationOptions = paginationFactory({
      sizePerPageList: [{
        value: 20
      }],
      paginationSize: 5,
      hideSizePerPage: true,
      alwaysShowAllBtns: true
    })

    return (
      <div className="tab-inner table-page employees">
        <BootstrapTable
          keyField='id'
          data={sortBy(collaborators, "lastName")}
          columns={columns}
          bordered={ false }
          striped
          hover
          condensed
          pagination={ paginationOptions } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Collaborators/index.js